import { IServerStoreSegment } from './server.interface';

export const serverStoreSelector = (state: IServerStoreSegment) => state.server;
